import React from "react";
import { Navigate } from "react-router-dom";

export function PrivateRoute(props: { isAuthorized: boolean, children: React.ReactNode }) {
    const { children, isAuthorized } = props;

    if (!isAuthorized) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
}